import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  ach_transfersDetail: {},
  ach_transfersCount: null,
  ach_transfersList: [],
  adjustmentsList: [],
  adjustmentsDetail: {},
  connectionsCount: null,
  connectionsDetail: {},
  connectionsList: [],
  boletosCount: null,
  boletosDetail: {},
  boletosList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
